import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const OOPS_M1_Strings = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Strings in C"
    videos={[
      "https://www.youtube.com/embed/bk-Bw7jzZK4", // String in C programming
    ]}
    takeaways={[
      {
        text: "Understand different types of string declarations and the meaning of '\\0' (null terminator) in a string.",
      },
      { text: "Learn all the common string-related operations." },
      {
        text: "Taking input for strings and manipulating strings using string operations.",
      },
    ]}
    questions={[
      "Implement strcmp, strlen, and strcpy functions without using in-built functions.",
      "Solve coding questions that involve string manipulation using string operations.",
      
    ]}
    exampleVideos={[]} // No extra example videos for now
  />
);
}

export default OOPS_M1_Strings;
